module.exports = __webpack_public_path__ + "static/media/chime.7ed6ffb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/chime.mp3
// module id = qE9O
// module chunks = 3